import * as Yup from "yup";

const Validation = Yup.object({
  coin: Yup.string().required("Please select a coin"),
  amount: Yup.number()
    .typeError("Amount must be a number")
    .positive("Amount must be greater than 0")
    .required("Amount is required"),
  type: Yup.string().required("Please select a type"),
  transactionType: Yup.string().required("Please select a transaction type"),
  comment: Yup.string().required("Comment is required"),
});

export default Validation;
